export default {"src":"/_next/static/media/maintenance.4eda0006.svg","height":472,"width":747,"blurWidth":0,"blurHeight":0};